<div *ngIf="createForm">

  <div class="container-fluid" [hidden]="indexPage < 1 || indexPage > 5">
    <div class="row">

      <div class="col-md-11">
        <div class="sticky-top fixedtop" *ngFor="let page of pages; let i = index">
          <div id="step{{ i+1 }}" *ngIf="indexPage === (i+1) && getIsCheckValid(indexPage)">
            <app-form-errors
              [stepid]="'_STEP_ID_' + (i+1)"
              [linkForRouter]="linkForRouter"
            >
            </app-form-errors>
          </div>
        </div>

        <div [class]="formClass">
          <fieldset>
            <legend *ngIf="indexPage > 0 && indexPage < 5">{{ getIntitule(indexPage) | translate }}</legend>

            <!-- Références de l'avis initial -->
            <app-step1 *ngIf="indexPage === 1" [uid]="getUid(1)" [parentForm]="form" [disabled]="disabled" [avisInitial]="ann.divers?.annulation?.avisInitial"
              [linkForRouter]="linkForRouter">
            </app-step1>

            <!-- Bloc 1. Identification de l'organisme qui passe le marché -->
            <app-step2 *ngIf="indexPage === 2" [uid]="getUid(2)" [parentForm]="form" [disabled]="disabled" [annulation]="ann.divers?.annulation"
              [linkForRouter]="linkForRouter">
            </app-step2>
            <app-step1common *ngIf="indexPage === 2" [uid]="getUidCommon(2)" [parentForm]="form" [disabled]="disabled" [divers]="ann.divers"
              [linkForRouter]="linkForRouter" [formName]="formName">
            </app-step1common>

            <!-- Bloc 3. Description du marché -->
            <app-step3 *ngIf="indexPage === 3" [uid]="getUid(3)" [parentForm]="form" [disabled]="disabled" [annulation]="ann.divers?.annulation"
               [linkForRouter]="linkForRouter">
            </app-step3>

            <!-- Bloc 4. Motif de l’annulation  -->
            <app-step4 *ngIf="indexPage === 4" [uid]="getUid(4)" [parentForm]="form" [disabled]="disabled" [annulation]="ann.divers?.annulation"
               [linkForRouter]="linkForRouter">
            </app-step4>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</div>
